module.exports = __webpack_public_path__ + "img/iskra_logo.da9be57c.png";